module.exports = __webpack_public_path__ + "img/error-icon.5aec1c1.svg";